module.exports = __webpack_public_path__ + "img/news.b557e31a.png";